import React from 'react';
/*
    Main Component
    --> state (Boolean Status)
    --> children (Child node/nodes)
*/

class Hide extends React.Component<{ state: any; children: any }> {
  render() {
    const { state, children } = this.props;
    const count = React.Children.count(children);
    if (count === 1) {
      return <>{state && <>{children}</>}</>;
    } else if (count === 2) {
      return <>{state ? <>{children[0]}</> : <>{children[1]}</>}</>;
    } else {
      return <>{children}</>;
    }
  }
}

export default Hide;
